import { ReactElement } from 'react';
import { toast } from 'react-toastify';

export const errorToast = (message: string, options = {}) => {
  toast.error(message, {
    autoClose: 10 * 1000,
    ...options
  });
};
export const warnToast = (message: string  |  ReactElement, options = {}) => {
  toast.warning(message, {
    autoClose: 10 * 1000,
    ...options
  });
};
